import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'
import { REGULAR_CHANGE_PASSWORD_MODAL } from './constants'
import { translate } from './helpers'

const RegularChangePasswordModal = Loadable(() => import('./RegularChangePasswordModal'))

export const createChangePasswordNavigationItem = createNavigationConfig((translateFn: (key: string) => string) => ({
  icon: 'key2',
  text: translate('frm_Sec_pass_change'),
  identity: REGULAR_CHANGE_PASSWORD_MODAL,
  component: RegularChangePasswordModal,
}))

export { REGULAR_CHANGE_PASSWORD_MODAL }
